export default __webpack_public_path__ + "static/media/smile.6cba7794.gif";